import { http } from 'http';

export default {
  saveData: (transactionId, data) =>
    http.patch(`/actas/devolucion/${transactionId}`, data, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    })
};
